export default __webpack_public_path__ + "static/media/flattr.205ceb44.svg";